import './domain-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { HypervisionState } from '@hypervision/hypervision-routing.module';
import { Domain } from '@hypervision/models/domain';
import { ISkillViewService } from '@hypervision/skill-view/skill-view.service';
import { forEach, IChangesObject, IComponentController, IComponentOptions, IFilterService, isDefined, isUndefined } from 'angular';

import { MessagingService } from '@contact/upgrade';

import { ISkillViewFilterService } from '../filter.service';
import templateUrl from './domain-filter.component.ajs.html';

const MODULE_NAME = 'skillViewDomainFilter';

class DomainFilterCtrl implements IComponentController {
  public name = MODULE_NAME;

  public filterView: string;
  public onChangeFilterView: Function;

  public currentView: string = 'filterDomains';
  public domainTree: Domain[] = [];
  public selectedDomainUuids: string[] = [];

  constructor(
    private readonly skillFilterHypervision: ISkillViewFilterService,
    private readonly skillHypervision: ISkillViewService,
    private readonly $filter: IFilterService,
    private readonly messaging: MessagingService
  ) {}

  $onInit() {
    this.skillHypervision.getDomainList().then((domains: Domain[]) => {
      let rootDomains: Domain[] = this.skillHypervision.getRootDomains(domains);
      if (isDefined(rootDomains)) {
        this.domainTree = rootDomains;
        this.buildDomainTree(this.domainTree, domains);
        // Select all domain by default
        this.selectedDomainUuids = domains.map(d => d.uuid);
      }
    });

    // filterChanged
    this.messaging
      .forLocal()
      .listen$('filterChanged')
      .pipe(ng1Destroy(this))
      .subscribe((data: any) => {
        if (data !== undefined && data.emitter === 'SkillTableCtrl') {
          let filter = this.skillFilterHypervision.getFilter(HypervisionState.SKILL_CUSTOM);
          if (isDefined(filter)) {
            this.selectedDomainUuids = [].concat(filter.domainUuids);
          }
        }
      });
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['filterView'] && isDefined(onChangesObj['filterView'].currentValue)) {
      this.filterView = onChangesObj['filterView'].currentValue;
    }
  }

  toggleSelection({ selectedDomain }) {
    if (isUndefined(selectedDomain)) return;
    // Update selected domain list
    let index = this.selectedDomainUuids.indexOf(selectedDomain.id);
    if (index >= 0) {
      this.selectedDomainUuids.splice(index, 1);
    } else {
      this.selectedDomainUuids.push(selectedDomain.id);
    }

    // Updates table data
    this.skillFilterHypervision.notifyDomainChange(HypervisionState.SKILL_CUSTOM, this.selectedDomainUuids);

    this.messaging.forLocal().publish('domainFilterChange', {
      domainUuids: this.selectedDomainUuids,
      viewName: HypervisionState.SKILL_CUSTOM,
      toggledDomainUuid: selectedDomain.id,
    });

    this.messaging.forLocal().publish('filterChanged', {
      emitter: 'SkillPersoDomainFilterCtrl',
    });
  }

  buildDomainTree(domainNodes: Domain[], domainList: Domain[]) {
    forEach(domainNodes, domainNode => {
      let children: any[] = [];
      for (let i = domainList.length - 1; i >= 0; i = i - 1) {
        if (domainList[i].parentUuid === domainNode.uuid) {
          children.push(domainList[i]);
        }
      }

      if (children.length > 0) {
        let sorted = this.$filter('orderBy')(children, 'name');
        this.buildDomainTree(children, domainList);

        forEach(sorted, child => domainNode.addChild(child));
      }
    });
  }

  isCurrentFilterView(): boolean {
    return this.filterView === this.currentView;
  }

  changeView() {
    this.onChangeFilterView({ $event: { filterView: this.currentView } });
  }
}

export class DomainFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    filterView: '<',
    onChangeFilterView: '&',
  };
  controller = ['skillFilterHypervision', 'skillHypervision', '$filter', 'messaging', DomainFilterCtrl];
}

export default MODULE_NAME;
